import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-ic-analysis-sidenav",
  templateUrl: "./ic-analysis-sidenav.component.html",
})
export class IcAnalysisSidenavComponent implements OnInit {
  tcCode = "";
  currentURL = "";

  constructor(private router: Router) {}

  ngOnInit() {
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode");
    }
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("analysis-appointments");
    }
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
